import router from "@/router";
import {calcCols} from "@/features/wishlist/WishListHelpers";

const state = {
	products: []
}

const getters = {
	userId(){
		return  router.currentRoute.query.userId;
	},
	userFirstName(){
		return router.currentRoute.query.ufname || '';
	},
	prodCodes() {
		const prods = router.currentRoute.query.products;
		return prods?.split(',');
	},
	cols(state) {
		const pc = state.products.length;
		return calcCols(pc);// pc % 2 === 0 ?  (pc / 2) + 1 : (pc + 1) / 2;
	},
	colMode(state) {
		return state.products.length % 2 === 0 ? 'even' : 'odd';
	},
}

const actions = {


	setProducts({commit}, products) {
		commit('setProducts', products);
	}
}

const mutations = {
	setProducts(state, products) {
		state.products = products;
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}
